import { NavLinksGroup } from "./NavLink.types";

export const NAV_LINK_GROUPS: NavLinksGroup[] = [
  {
    type: "superData",
    items: [
      { type: "platforms" },
      { type: "sports" },
      { type: "disciplines" },
      { type: "thirdPartyLicenses" },
      { type: "stripeConnect" },
    ],
  },
  {
    type: "governing",
    items: [
      { type: "platformManagers" },
      { type: "managementTeam" },
      { type: "organizations" },
      { type: "licenses" },
      { type: "issuedLicenses" },
      { type: "certificates" },
      { type: "issuedCertificates" },
      { type: "applicationForms" },
      { type: "issuedApplicationForms" },
    ],
  },
  {
    type: "data",
    items: [
      { type: "leagues" },
      { type: "clubs" },
      { type: "tournaments" },
      { type: "users" },
      { type: "coaches" },
      { type: "teams" },
      { type: "auditLogs" },
    ],
  },
  {
    type: "settings",
    items: [
      { type: "platformSettings" },
      { type: "organizationSettings" },
      { type: "userSettings" },
    ],
  },
  {
    type: "appearance",
    items: [
      { type: "pages" },
      { type: "news" },
      { type: "gallery" },
      { type: "documents" },
      { type: "banners" },
      { type: "partners" },
    ],
  },
  {
    type: "finance",
    items: [{ type: "transactions" }, { type: "platformStripeAccounts" }],
  },
  {
    type: "other",
    items: [{ type: "tutorials" }, { type: "contactSupport" }, { type: "helpCenter" }],
  },
];
